import React from 'react';
import { useHistory } from 'react-router-dom';
import SitefConfigForm from 'forms/SitefConfigForm';
import EditSitefConfigContext from 'contexts/EditSitefConfigContext';
import { getSitefConfig } from 'services/sitefServices';
import SitefConfig from 'types/models/SitefConfig';

export default (): JSX.Element => {
  const history = useHistory();
  const { selectedSitefConfig } = React.useContext(EditSitefConfigContext);
  const [completeSitefConfig, setCompleteSitefConfig] = React.useState<SitefConfig | null>(null);

  const load = React.useCallback(async (id: string) => {
    const sitefConfig = await getSitefConfig(id);
    if (!sitefConfig) {
      history.push('/private/admin/payments/sitef');
      return;
    }
    setCompleteSitefConfig(sitefConfig);
  }, []);

  React.useEffect(() => {
    if (!selectedSitefConfig) {
      history.push('/private/admin/payments/sitef');
    } else {
      load(selectedSitefConfig.id);
    }
  }, [selectedSitefConfig]);

  if (!completeSitefConfig) return <></>;
  return <SitefConfigForm config={completeSitefConfig} />;
};
